<template>
  <div id="app">
    <!-- <img src="@/assets/images/bg.jpg" alt="" /> -->
    <transition name="slide" mode="out-in">
        <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: #6c90a8;
}
img {
  display: block;
  width: 100%;
  height: 100%;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}
.slide-leave, .slide-enter-to {
  transform: translateX(0); /* 初始位置 */
}
</style>
<style lang="scss" scope>
</style>
